'use strict';

var React = require('react');
var onEnter = require('./onEnter');

class DatePickerHeader extends React.Component {

  render() {

    var props = this.props;

    return React.createElement(
      'div',
      { className: 'dp-header' },
      React.createElement(
        'div',
        { className: 'dp-nav-table' },
        React.createElement(
          'div',
          { className: 'dp-row' },
          React.createElement(
            'div',
            {
              tabIndex: '1',
              role: 'link',
              className: 'dp-prev-nav dp-nav-cell dp-cell',
              onClick: props.onPrev,
              onKeyUp: onEnter(props.onPrev)
            },
            props.prevText
          ),
          React.createElement(
            'div',
            {
              tabIndex: '1',
              role: 'link',
              className: 'dp-nav-view dp-cell',
              colSpan: props.colspan,
              onClick: props.onChange,
              onKeyUp: onEnter(props.onChange)
            },
            props.children
          ),
          React.createElement(
            'div',
            {
              tabIndex: '1',
              role: 'link',
              className: 'dp-next-nav dp-nav-cell dp-cell',
              onClick: props.onNext,
              onKeyUp: onEnter(props.onNext)
            },
            props.nextText
          )
        )
      )
    );
  }
}

DatePickerHeader.displayName = 'DatePickerHeader';

// React 19 doesn't check propTypes. Kept, commented out, as the record of
// this component's props for the TypeScript migration.
// DatePickerHeader.propTypes = {
//   onChange: PropTypes.func,
//   onPrev: PropTypes.func,
//   onNext: PropTypes.func,
//   colspan: PropTypes.number,
//   children: PropTypes.node
// };

module.exports = DatePickerHeader;
